import Scroller from "./Scroller";
import SimpleScroller from "./SimpleScroller";
export default Scroller;

export {SimpleScroller}
